/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // // Debounced scroll listeners.  Up and down only fire on direction changes
  // // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // // Locks and unlocks page scroll for modals and drawers
  // // These are commented out because firing them will lock the page scroll
  // // the lock event must set `detail` to the modal or drawer body so the 
  // // scroll locking code knows what element should maintain scoll. 
  // // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Multi-variant quantity controls (B2B)
  const multiVariantList = document.querySelector('[data-multi-variant-list]');
  if (multiVariantList) {
    // Get the add to cart button and minimum quantity
    const addToCartButton = document.querySelector('[data-add-to-cart]');
    const productForm = document.querySelector('[data-product-form]');
    const variantBlock = document.querySelector('.product__block__variants--multi');
    const minQty = parseInt(variantBlock?.getAttribute('data-min-qty')) || 10;

    // Check if button should be disabled
    function updateAddToCartButton() {
      if (!addToCartButton) return;

      const inputs = multiVariantList.querySelectorAll('[data-variant-qty-input]');
      let hasValidQuantity = false;

      inputs.forEach(input => {
        const qty = parseInt(input.value) || 0;
        if (qty >= minQty) {
          hasValidQuantity = true;
        }
      });

      if (hasValidQuantity) {
        addToCartButton.removeAttribute('disabled');
        addToCartButton.querySelector('[data-add-to-cart-text]').textContent = 'Add to cart';
      } else {
        addToCartButton.setAttribute('disabled', 'disabled');
        addToCartButton.querySelector('[data-add-to-cart-text]').textContent = 'Add to cart';
      }
    }

    // Handle quantity decrease
    multiVariantList.addEventListener('click', function(e) {
      const decreaseBtn = e.target.closest('[data-qty-decrease]');
      if (decreaseBtn) {
        const row = decreaseBtn.closest('.multi-variant-row');
        const input = row.querySelector('[data-variant-qty-input]');
        const currentValue = parseInt(input.value) || 0;
        let newValue;

        if (currentValue === 0) {
          // Can't go below 0
          return;
        } else if (currentValue === minQty) {
          // Jump from minimum to 0
          newValue = 0;
        } else {
          // Decrease by 1
          newValue = currentValue - 1;
        }

        input.value = newValue;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateAddToCartButton();
      }
    });

    // Handle quantity increase
    multiVariantList.addEventListener('click', function(e) {
      const increaseBtn = e.target.closest('[data-qty-increase]');
      if (increaseBtn) {
        const row = increaseBtn.closest('.multi-variant-row');
        const input = row.querySelector('[data-variant-qty-input]');
        const currentValue = parseInt(input.value) || 0;
        let newValue;

        if (currentValue === 0) {
          // Jump from 0 to minimum
          newValue = minQty;
        } else {
          // Increase by 1
          newValue = currentValue + 1;
        }

        input.value = newValue;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateAddToCartButton();
      }
    });

    // Validate numeric input
    multiVariantList.addEventListener('input', function(e) {
      const input = e.target.closest('[data-variant-qty-input]');
      if (input) {
        let value = parseInt(input.value) || 0;

        // Can't be negative
        if (value < 0) {
          value = 0;
        }

        // Can't be between 1 and minQty (exclusive)
        if (value > 0 && value < minQty) {
          value = minQty;
        }

        input.value = value;
        updateAddToCartButton();
      }
    });

    // Override the add to cart functionality for multi-variant
    if (addToCartButton && productForm) {
      // Remove the Alpine.js click handler and add our own
      addToCartButton.addEventListener('click', function(e) {
        // Check if this is a multi-variant form
        if (!multiVariantList) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        // Collect all variants with quantities >= minQty
        const inputs = multiVariantList.querySelectorAll('[data-variant-qty-input]');
        const items = [];

        inputs.forEach(input => {
          const qty = parseInt(input.value) || 0;
          const variantId = input.getAttribute('data-variant-id');
          if (qty >= minQty && variantId) {
            items.push({
              id: variantId,
              quantity: qty
            });
          }
        });

        if (items.length === 0) {
          return;
        }

        // Reverse the order so they appear correctly in cart
        items.reverse();

        // Add loading state
        addToCartButton.classList.add('loading');
        addToCartButton.setAttribute('disabled', 'disabled');

        // Use Shopify's cart API to add multiple items
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        })
        .then(response => response.json())
        .then(data => {
          // Success - update cart count and show success state
          addToCartButton.classList.remove('loading');
          addToCartButton.classList.add('has-success');

          // Get updated cart data
          return fetch(window.Shopify.routes.root + 'cart.js')
            .then(res => res.json())
            .then(cart => {
              // Dispatch cart change event
              document.dispatchEvent(new CustomEvent('theme:cart:change', {
                detail: { cart: cart },
                bubbles: true
              }));

              // Reset quantities
              inputs.forEach(input => {
                input.value = 0;
              });

              // Reset button state after delay
              setTimeout(() => {
                addToCartButton.classList.remove('has-success');
                addToCartButton.setAttribute('disabled', 'disabled');
                updateAddToCartButton();
              }, 1000);

              // Open cart drawer
              const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
              if (cartDrawer) {
                cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
                  bubbles: false
                }));
              }
            });
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          addToCartButton.classList.remove('loading');
          addToCartButton.removeAttribute('disabled');
          updateAddToCartButton();
        });
      }, true); // Use capture to intercept before Alpine.js

      // Initial button state
      updateAddToCartButton();
    }
  }

  // Single product quantity controls (B2B minimum quantity)
  const productQuantitySelector = document.querySelector('[data-product-quantity-selector]');
  if (productQuantitySelector && !multiVariantList) {
    const quantityInput = productQuantitySelector.querySelector('[data-quantity-input]');
    const minQty = parseInt(quantityInput?.getAttribute('data-min-qty')) || 10;

    // Handle decrease button
    productQuantitySelector.addEventListener('click', function(e) {
      const decreaseBtn = e.target.closest('[data-decrease-quantity]');
      if (decreaseBtn) {
        e.preventDefault();
        e.stopPropagation();

        const currentValue = parseInt(quantityInput.value) || 0;
        let newValue;

        if (currentValue === 0) {
          // Can't go below 0
          return;
        } else if (currentValue === minQty) {
          // Jump from minimum to 0
          newValue = 0;
        } else {
          // Decrease by 1
          newValue = currentValue - 1;
        }

        quantityInput.value = newValue;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, true);

    // Handle increase button
    productQuantitySelector.addEventListener('click', function(e) {
      const increaseBtn = e.target.closest('[data-increase-quantity]');
      if (increaseBtn) {
        e.preventDefault();
        e.stopPropagation();

        const currentValue = parseInt(quantityInput.value) || 0;
        let newValue;

        if (currentValue === 0) {
          // Jump from 0 to minimum
          newValue = minQty;
        } else {
          // Increase by 1
          newValue = currentValue + 1;
        }

        quantityInput.value = newValue;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, true);

    // Validate numeric input
    if (quantityInput) {
      quantityInput.addEventListener('input', function(e) {
        let value = parseInt(e.target.value) || 0;

        // Can't be negative
        if (value < 0) {
          value = 0;
        }

        // Can't be between 1 and minQty (exclusive)
        if (value > 0 && value < minQty) {
          value = minQty;
        }

        e.target.value = value;
      });
    }
  }

  // Intercept cart change requests to enforce minimum quantity
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;

    // Check if this is a cart change request
    if (url && url.includes('cart/change.js') && options && options.body) {
      try {
        const body = JSON.parse(options.body);

        // Find the cart item being updated
        const cartItem = document.querySelector(`[data-cart-item] [data-update-cart="${body.id}"]`);
        if (cartItem) {
          const lineItem = cartItem.closest('[data-cart-item]');
          const minQty = parseInt(lineItem.getAttribute('data-min-qty')) || 10;

          // Enforce minimum quantity: 0 or >= minQty
          if (body.quantity > 0 && body.quantity < minQty) {
            body.quantity = minQty;
            options.body = JSON.stringify(body);
            args[1] = options;
          }
        }
      } catch (e) {
        // If parsing fails, just continue with original request
        console.error('Error enforcing minimum quantity:', e);
      }
    }

    return originalFetch.apply(this, args);
  };

  // Update cart quantity button states
  function updateCartQuantityButtons() {
    const cartItems = document.querySelectorAll('[data-cart-item]');

    cartItems.forEach(item => {
      const input = item.querySelector('[data-quantity-input]');
      const decreaseBtn = item.querySelector('[data-decrease-quantity]');

      if (!input || !decreaseBtn) return;

      const minQty = parseInt(item.getAttribute('data-min-qty')) || 10;
      const currentValue = parseInt(input.value) || 0;

      // Disable minus button when at 0 or at minimum
      if (currentValue === 0 || currentValue === minQty) {
        decreaseBtn.setAttribute('disabled', 'disabled');
      } else {
        decreaseBtn.removeAttribute('disabled');
      }
    });
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', function() {
    updateCartQuantityButtons();
  });

  // Run when cart updates
  document.addEventListener('theme:cart:change', function() {
    setTimeout(updateCartQuantityButtons, 250);
  });

  // Run when drawer opens
  document.addEventListener('theme:drawer:open', function() {
    setTimeout(updateCartQuantityButtons, 150);
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
